import { useQuery } from '@tanstack/react-query';
import { feedbackApi } from '../api/feedback';
import type { FeedbackMineListFilter } from '../types/feedback';

interface UseMyFeedbackOptions {
  enabled?: boolean;
  /** queue #691 §R691-2(a): 헤더 배지 폴링(60s) — 미지정 시 폴링 없음(기존 다이얼로그 호출부 무영향) */
  refetchInterval?: number;
  /** 탭 비활성 시 폴링 정지 — 배지 호출부는 false 로 명시(과도 폴링 금지 · §R691-8) */
  refetchIntervalInBackground?: boolean;
  staleTime?: number;
}

/**
 * GET /api/eraf/catalog/feedback/mine — 인증-any(본인 제출분만 · queue #684 §UAT-2026-07-14-R684 §R684-3③).
 * queryKey: ['common-showcase', 'feedback', 'mine', filters]
 */
export function useMyFeedback(filter: FeedbackMineListFilter = {}, options?: UseMyFeedbackOptions) {
  return useQuery({
    queryKey: ['common-showcase', 'feedback', 'mine', filter],
    queryFn: () => feedbackApi.mine(filter),
    staleTime: options?.staleTime ?? 10_000,
    enabled: options?.enabled ?? true,
    refetchInterval: options?.refetchInterval,
    refetchIntervalInBackground: options?.refetchIntervalInBackground,
  });
}
